import { createRouter, createWebHistory } from "vue-router"
const router=createRouter({
    history:createWebHistory(),
    routes:[ 
    {
      path: '/onther',
      component: () => import('@/layout/layoutOther.vue'),
      children:[
        {
 
          path: 'algorithmMall',
     
          name: 'algorithmMall',
     
          component: () => import('@/views/algorithmMall/algorithmMall.vue')        //路由懒加载按需导入
     
        },
        {
     
          path: 'algorithmMallDetails',
     
          name: 'algorithmMallDetails',
     
          component: () => import('@/views/algorithmMall/algorithmMallDetails.vue')        //路由懒加载按需导入
     
        },
        {
     
          path: '/',
     
          name: 'homePage',
     
          component: () => import('@/views/homePage/homePage.vue')        //路由懒加载按需导入
     
        },
        {
          path: 'productDetails',
          name: 'productDetails',
          component: () => import('@/views/homePage/productDetails.vue')
        },
        {
          path: 'contactUs',
          name: 'contactUs',
          component: () => import('@/views/contactUu/contactUs.vue')

        },
        {
          path: 'solutions',
          name: 'solutions',
          component: () => import('@/views/solutions/solutionsView.vue')

        },
        {
          path: 'solutionsList',
          name: 'solutionsList',
          component: () => import('@/views/solutions/solutionsList.vue')

        },
        {
          path: 'aboutUs',
          name: 'aboutUs',
          component: () => import('@/views/aboutUs/aboutUs.vue')

        },
        {
          path: 'solutionsDetails',
          name: 'solutionsDetails',
          component: () => import('@/views/solutions/solutionsDetails.vue')

        },
      ]
  
    }
 
],
})

// 在router.js中添加路由前置守卫，在路由跳转之前，完成让页面回到顶部
router.beforeEach((to, from, next) => {
 
  // 路由跳转后，让页面回到顶部
  document.body.scrollTop = 0; 
  document.documentElement.scrollTop = 0; 
  window.pageYOffset = 0; 
  next();
 
});
export default router